import { render, staticRenderFns } from "./ResetSceneButton.vue?vue&type=template&id=e0c66d26&"
import script from "./ResetSceneButton.vue?vue&type=script&lang=js&"
export * from "./ResetSceneButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports